import alt from 'framework/alt';
import AccountActions from 'actions/AccountActions';

class AccountStore {
  constructor() {
    this.state = {
      account: undefined,
      error: undefined,
      isLoading: false,
    };

    this.bindListeners({
      createStarted: AccountActions.createStarted,
      createSucceeded: AccountActions.createSucceeded,
      createFailed: AccountActions.createFailed,
      completeAccountForLegacyUserStarted: AccountActions.completeAccountForLegacyUserStarted,
      completeAccountForLegacyUserSucceeded: AccountActions.completeAccountForLegacyUserSucceeded,
      completeAccountForLegacyUserFailed: AccountActions.completeAccountForLegacyUserFailed,
    });
  }

  completeAccountForLegacyUserStarted() {
    this.setState({ isLoading: true });
  }

  completeAccountForLegacyUserSucceeded() {
    this.setState({ isLoading: false });
  }

  completeAccountForLegacyUserFailed(err) {
    this.setState({ error: err, isLoading: false });
  }

  createStarted() {
    this.setState({ isLoading: true });
  }

  createSucceeded(account) {
    this.setState({
      account,
      error: null,
      isLoading: false,
    });
  }

  createFailed(err) {
    this.setState({ error: err, isLoading: false });
  }
}

export default alt.createStore(AccountStore, 'AccountStore');
